import React from "react"
import {Button, Form, FormGroup, FormText, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {goBack, push} from "connected-react-router";
import {connect} from "react-redux";
import {startVerification} from "../../actions/verifActions";
import {fetchDeposit, updateDeposit} from "../../actions/depositActions";

import {toast} from "react-toastify"

class DepositEdit extends React.Component {

  constructor(props) {
    super(props);
    if (props.deposit){
      //toast.success("Pre fetched")
    }else{
      props.fetchDeposit(props.depo_id)
    }

    this.state = null

    this.onSubmit = this.onSubmit.bind(this)
    this.onChange = this.onChange.bind(this)
  }

  onSubmit() {
    if (this.state){
      this.props.updateDeposit(this.props.depo_id, this.state)
    }else{
      toast.warn("No values changed")
    }
  }

  onChange(el) {
    this.setState({[el.target.name]: el.target.value})
  }

  render() {
    const { fetching, deposit} = this.props

    if (fetching)
      return "Fetching"

    if (deposit)
      return (
        <Form>
          <FormGroup>
            <Label for="name">Deliveryn ame</Label>
            <Input type="text" name="name" id="name" placeholder="Deposit name" onChange={this.onChange} defaultValue={deposit.name}/>
          </FormGroup>
          <FormGroup>
            <Label for="contract_id">Contract ID</Label>
            <Input type="text" name="contract_id" id="contract_id" placeholder="Contract ID" onChange={this.onChange} defaultValue={deposit.contract_id}/>
          </FormGroup>
          <FormGroup>
            <Label for="file">File</Label>
            <Input type="text" name="file" id="file" placeholder="File path" onChange={this.onChange} defaultValue={deposit.file}/>
          </FormGroup>
          <Button onClick={this.onSubmit}>Save</Button>
        </Form>
      )

    return null
  }
}

const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
  fetchDeposit: (depoId) => dispatch(fetchDeposit(depoId)),
  updateDeposit: (depoId, newdata) => dispatch(updateDeposit(depoId, newdata)),
})

const mapStateToProps = (state) => ({
  fetching: state.deposit.fetching,
  fetched: state.deposit.fetched,
  deposit: state.deposit.deposit,
  error: state.deposit.error,
})

export default connect(mapStateToProps, mapDispatchToProps)(DepositEdit)



// WEBPACK FOOTER //
// ./src/components/Deposits/DepositEdit.js